export enum ClientMode {
  Application = 'Application',
  Widget = 'Widget',
  ProxyServer = 'Proxy'
}